import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
/* import { Observable } from 'rxjs'; */

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class SignuuService {

    constructor(private http:HttpClient) {
    }

    public serviceUrl = 'https://v2api.signuu.com';

    getOrganizations() {
        return this.http.get(this.serviceUrl + '/organizations');
    }

    // Uses Observable.forkJoin() to run multiple concurrent http.get() requests.
    // The entire operation will result in an error state if any single request fails.
    /*
    getProductsAndPictures() {
        return Observable.forkJoin(
            this.http.get(this.serviceUrl + '/products'),
            this.http.get(this.serviceUrl + '/pictures')
        );
    }*/

    getSession(identifier) {
        return this.http.get(this.serviceUrl + '/sessions?identifier=' + identifier);
    }

    // send a POST request to the API to create a new data object
    createSession(session) {
        console.log(session);
        console.log(this.serviceUrl);
        let body = JSON.stringify(session);
        return this.http.post(this.serviceUrl + '/sessions', body, httpOptions);
    }

    // send a PUT request to the API to update a data object
    updateSession(session) {
        let body = JSON.stringify(session);
        return this.http.put(this.serviceUrl + '/sessions/' + session.id, body, httpOptions);
    }

    // send a DELETE request to the API to delete a data object
    deleteSession(session) {
        return this.http.delete(this.serviceUrl + '/sessions/' + session.id);
    }

}
